<template>
  <icon :style="{ color: 'hotpink',fontSize: '24px' }">
    <template #component>
      <svg t="1682216321027" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="2859" width="1em" height="1em">
        <path
            d="M540.672 273.92c-8.192-4.096-18.432-2.56-25.6 3.072l-138.24 115.2-110.08-0.512c-6.144 0-12.288 2.56-16.896 7.168-4.608 4.608-7.168 10.752-7.168 16.896l-0.512 192.512c0 6.144 2.56 12.288 7.168 16.896 4.608 4.608 10.752 7.168 16.896 7.168h111.616l137.728 114.688c4.608 3.584 9.728 5.632 15.36 5.632 3.584 0 7.168-0.512 10.24-2.048 8.192-4.096 13.824-12.288 13.824-22.016V295.424c-0.512-9.216-5.632-17.408-14.336-21.504zM633.856 394.24c-11.776-5.632-26.112-0.512-31.744 11.264-5.632 11.776-1.024 26.112 10.752 32.256 1.536 1.024 37.376 19.456 37.376 72.704 0 56.832-33.792 75.776-34.816 76.288-11.776 6.144-16.896 20.48-10.752 32.256 4.096 8.192 12.8 13.312 21.504 13.312 3.584 0 7.168-1.024 10.752-2.56 2.56-1.024 61.44-31.744 61.44-119.296 0.512-84.992-61.952-115.2-64.512-116.224z m74.752-70.656c-11.264-7.168-25.6-4.096-33.28 7.168-7.168 11.264-4.096 26.112 7.168 33.28 2.56 1.536 64 43.52 64 147.968s-58.88 146.432-61.44 148.48c-11.264 7.168-13.824 22.528-6.656 33.28 4.608 7.168 12.288 10.752 19.968 10.752 4.608 0 9.216-1.536 13.312-4.096 3.584-2.048 82.944-56.832 82.944-188.416 0.512-132.096-82.432-186.368-86.016-188.416zM1024 512c0 282.624-229.376 512-512 512S0 794.624 0 512 229.376 0 512 0s512 229.376 512 512z"
            p-id="2860" fill="#1296db"></path>
      </svg>
    </template>
  </icon>
</template>

<script>
// zhouhan@cibr.ac.cn 2023/4/23 10:18
import Icon from "@ant-design/icons-vue";

export default {
  name: "playSound",
  components: {Icon},

}
</script>

<style scoped>

</style>